<template>
  <div class="pusher">
    <!-- Page Contents -->
    <div id="home-section" class="ui inverted vertical masthead center aligned segment">

      <div class="ui container">
        <div class="ui large secondary inverted pointing menu">
          <a class="toc item">
            <i class="sidebar icon"></i>
          </a>
          <router-link :to="{name: 'Hello'}" class="item">About</router-link>
          <!-- <a href="/#/#data-section" class="item">Data</a> -->
          <router-link :to="{name: 'Pricing'}" class="item">Pricing</router-link>
          <div class="right item">
            <router-link :to="{name: 'Login'}" class="ui inverted button">Login In</router-link>
            <router-link :to="{name: 'Signup'}" class="ui inverted button">Sign Up</router-link>
          </div>
        </div>
      </div>

      <div class="ui text container">
        <h1 class="ui inverted header">
          VX Data
        </h1>
        <h2>Latest real estate market data</h2>
        <router-link :to="{name: 'Signup'}" class="ui huge primary button">Get Started <i class="right arrow icon"></i></router-link>
      </div>

    </div>

    <div id="data-section" class="ui vertical stripe segment">
      <div class="ui middle aligned stackable grid container">
        <div class="row">
          <div class="eight wide column">
            <h3 class="ui header">Latest market data available each week</h3>
            <p>Every week we take a snapshot of the housing market across the entire US.</p>
            <h3 class="ui header">Simple data format</h3>
            <p>Plain old CSV, already clean, easy to load into your pipeline. (See example CSV.)</p>
            <h3 class="ui header">Historical data, going back ten years*</h3>
           <p>We've been doing this a while. With all plans, you'll get the last 12 months of market data.</p>
           <small>*historical data is available at additional cost.</small>
          </div>
          <div class="six wide right floated column">
            <img src="static/anna-goncharova-73258.jpg" class="ui large bordered rounded image">
          </div>
        </div>
        <div class="row">
          <div class="center aligned column">
            <router-link :to="{name: 'Signup'}" class="ui huge primary butto">Sign Up</router-link>
          </div>
        </div>
      </div>
    </div>


    <div class="ui vertical stripe quote segment">
      <div class="ui equal width stackable internally celled grid">
        <div class="center aligned row">
          <div class="column">
            <h3>"Up and running in minutes"</h3>
            <p>That is what they all say about us</p>
          </div>
          <div class="column">
            <h3>"No munging required."</h3>
            <p>
              <img src="assets/images/avatar/nan.jpg" class="ui avatar image"> <b>Sheila</b> Chief Data Scientist Acme Toys
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="ui vertical stripe segment">
      <div class="ui text container">
        <h3 class="ui header">Breaking The Grid, Grabs Your Attention</h3>
        <p>Instead of focusing on content creation and hard work, we have learned how to master the art of doing nothing by providing massive amounts of whitespace and generic content that can seem massive, monolithic and worth your attention.</p>
        <a class="ui large button">Read More</a>
        <h4 class="ui horizontal header divider">
          <a href="#">Case Studies</a>
        </h4>
        <h3 class="ui header">Did We Tell You About Our Bananas?</h3>
        <p>Yes I know you probably disregarded the earlier boasts as non-sequitur filler content, but its really true. It took years of gene splicing and combinatory DNA research, but our bananas can really dance.</p>
        <a class="ui large button">I'm Still Quite Interested</a>
      </div>
    </div>

    <div class="ui inverted vertical footer segment">
      <div class="ui container">
        <div class="ui stackable inverted divided equal height stackable grid">
          <div class="three wide column">
            <h4 class="ui inverted header">About</h4>
            <div class="ui inverted link list">
              <a href="#" class="item">Sitemap</a>
              <a href="#" class="item">Contact Us</a>
              <a href="#" class="item">Religious Ceremonies</a>
              <a href="#" class="item">Gazebo Plans</a>
            </div>
          </div>
          <div class="three wide column">
            <h4 class="ui inverted header">Services</h4>
            <div class="ui inverted link list">
              <a href="#" class="item">Banana Pre-Order</a>
              <a href="#" class="item">DNA FAQ</a>
              <a href="#" class="item">How To Access</a>
              <a href="#" class="item">Favorite X-Men</a>
            </div>
          </div>
          <div class="seven wide column">
            <h4 class="ui inverted header">Footer Header</h4>
            <p>Extra space for a call to action inside the footer that could help re-engage users.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var $ = window.$

export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted: function () {
    $('.ui.sidebar')
      .sidebar('attach events', '.toc.item')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?9225c6ba